import React from 'react';
import { FormComponent } from '../index';
import FieldMapWrapper from '../../../pages/crop/fields-and-works/fields/components/field-map-wrapper';
import { useFormContext } from 'react-hook-form';
import MapActionType from '../../../enums/map-action-type';

export type ActionType =
  | 'edit'
  | 'create'
  | 'lad'
  | 'default'
  | 'split'
  | 'identify';

export default function Map(
  type: ActionType,
  fieldName?: string,
  height?: number,
  zoomToMainFeature?: boolean
): FormComponent {
  return ({ ...rest }) => (
    <MapComponent
      type={type}
      fieldName={fieldName}
      height={height}
      zoomToMainFeature={zoomToMainFeature}
      {...rest}
    />
  );
}

export function MapComponent({
  type,
  fieldName,
  height,
  zoomToMainFeature,
}: {
  type: ActionType;
  fieldName: string;
  height?: number;
  zoomToMainFeature?: boolean;
}) {
  const { getValues, setValue, watch, trigger } = useFormContext();
  const fieldList = fieldName ? getValues()?.[fieldName] ?? [] : [];
  const field = getValues();

  const isSplitActive = watch('isSplitActive');
  const isMergeActive = watch('isMergeActive');
  const deleteWaypoint = watch('deleteWaypoint');
  const submitted = watch('submitted');
  const mapLoaded = watch('map_loaded');
  const hasGeometryChanged = watch('geometry');

  const saveDataOnForm = (values) => {
    Object.entries(values).forEach((e) => {
      const key = e[0];
      const value = e[1];

      setValue(key, value);
    });

    trigger('geometry')
  };

  return (
    <FieldMapWrapper
      field={[field, ...fieldList]}
      setField={saveDataOnForm}
      height={height}
      isEditActive={type === MapActionType.edit && !!field?.initial_geometry}
      isDrawingActive={
        type === MapActionType.create ||
        (type === MapActionType.edit && !field?.initial_geometry)
      }
      isIdentifyActive={type === MapActionType.identify}
      isSplitActive={type === MapActionType.edit && isSplitActive}
      isMergeActive={type === MapActionType.edit && isMergeActive}
      zoomToMainFeature={zoomToMainFeature}
      setValue={setValue}
      mainFieldId={field?.id}
      type={type}
      deleteWaypoint={deleteWaypoint}
      submitted={submitted}
      mapLoaded={mapLoaded}
      hasGeometryChanged={hasGeometryChanged}
    />
  );
}
